export default __webpack_public_path__ + "static/media/graph.beec2d69.svg";